import React from 'react';
import Navbar from '../Navbar/Navbar'
import CoursesCatScreen from './CoursesCatScreen';

function CoursesHomeScreen() {

    return (
        <div>

            <CoursesCatScreen />
        </div>
    );

}

export default CoursesHomeScreen;
